import request from '../utils/request';

export const getArticleRedeemCodeList = (queryDTO = {}) => {
  return request({
    url: '/article-redeem-code/list',
    method: 'post',
    data: queryDTO
  });
};

export const getArticleRedeemCodeById = (id) => {
  return request({
    url: `/article-redeem-code/${id}`,
    method: 'get'
  });
};

export const createArticleRedeemCode = (data) => {
  return request({
    url: '/article-redeem-code',
    method: 'post',
    data
  });
};

export const updateArticleRedeemCode = (id, data) => {
  return request({
    url: `/article-redeem-code/${id}`,
    method: 'put',
    data
  });
};

export const deleteArticleRedeemCode = (id) => {
  return request({
    url: `/article-redeem-code/${id}`,
    method: 'delete'
  });
};